import {checkIfItIsEmpty} from
    "./../../../functions/checks/checkIfItIsEmpty.js";   

import {globalVar} from 
    "./../../../variables/global_variables.js";


export function render(){

    this.getId(); 

    let output = "";

    if( this.menuType === "default"){

        output = this.getDefaultSideMenu();        
        

    }else if( this.menuType === "expandable" ){

        output = this.getExpandableSideMenu();        

    };


    /**** CREATE AN OBJECT FOR THE SIDE MENU TO STORE THINGS LIKE CUSTOM FUNCTIONS THAT AFFECTS IT ****/
    
    if( checkIfItIsEmpty(globalVar["sideMenues"]) ){
        
        globalVar["sideMenues"] = {};

    };

    /**** 
     * 
     * STORE THE INSTANCE OF THIS CLASS IN THE GLOBAL VARIABLE  
     *
     * 
     * ****/

    globalVar["sideMenues"][`${this.id}`] = this;

    return output;


};
